module.exports = __webpack_public_path__ + "static/media/tipoComprobante.c48d846c.png";